import { QRCodeSVG } from "qrcode.react"
import { ReactComponent as PlayersLoungeLogo } from "../../assets/logo/players-lounge-logo.svg"
// the floating controller from www.playerslounge.com's hero, the float itself is css since framer animates it in js there
import floatingController from "../../assets/images/floating-controller.png"
import './referral-qr-code.css'
import { Side } from "../../helpers/overlay-settings"
import { envVariables } from "../../helpers/env-variables"

// plc-app (web/app/referral-code-capture.tsx) stores ?ref= from any landing url and prefills it on the register form,
// so sending people straight to register saves a step
const getReferralUrl = (code: string) => `${envVariables.APP_URL}/register?ref=${encodeURIComponent(code)}`
// streamers without an active referral code still get a sign up qr, just without the bonus
const FALLBACK_URL = 'https://www.playerslounge.com'

// stays on screen for the whole stream, it only slides in once on load
export const ReferralQrCode = ({ code, side }: { code?: string | null, side: Side }) => {
  return (
    <div className={`referral_qr_code__wrapper referral_qr_code__wrapper--${side}`}>
      <img src={floatingController} alt="" className="referral_qr_code__controller" />
      <PlayersLoungeLogo className="referral_qr_code__logo" />
      <div className="referral_qr_code__body">
        <QRCodeSVG value={code ? getReferralUrl(code) : FALLBACK_URL} size={96} fgColor="var(--pl-content)" bgColor="transparent" />
        <div className="referral_qr_code__copy">
          <span className="referral_qr_code__heading pl-fontMContrast">Join Players Lounge</span>
          <span className="referral_qr_code__subheading pl-fontS">
            {code ? 'Scan to sign up and get a bonus' : 'Scan to sign up'}
          </span>
          {code && (
            // for viewers who can't scan, they can type it in on the register form instead
            <span className="referral_qr_code__code pl-fontXS">
              Code <span className="referral_qr_code__code_value pl-fontXSContrast">{code}</span>
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
